import { geometry } from 'app/contracts/Geometry';
import { particles } from 'app/contracts/Particles';
import { LookupType } from 'app/enum/Particles';
import { TweenLookupTable, TweenLookupTableParams } from 'particles/lookups/TweenLookupTable';

export class TriLookup implements particles.ParticleLookup {
	private _path: Array<particles.ParticleLookupProps> = [];
	private _x: number;
	private _y: number;
	private _distance: number;
	private _i: number;

	constructor() {
		let steps: number = 360;

		let targetPoints: Array<TweenLookupTableParams> = [
			{ start: { x: -0.7, y: -1 }, end: { x: -0.7, y: 1.2 }, pointCount: Math.round(steps * 0.333333333333333) },
			{ start: { x: -0.7, y: 1.2 }, end: { x: 1.1, y: 0 }, pointCount: Math.round(steps * 0.333333333333333) },
			{ start: { x: 1.1, y: 0 }, end: { x: -0.8, y: -1 }, pointCount: Math.round(steps * 0.333333333333333) }
		];

		let lookup: TweenLookupTable = new TweenLookupTable();
		let tweenPoints: Array<geometry.Vector2> = lookup.multiTween(targetPoints);

		tweenPoints.forEach((point: geometry.Vector2, index: number) => {
			Math.abs(index - steps / 2) / (steps / 2);
			this._path.push({
				x: point.x,
				y: point.y,
				scale: 0.5,
				alpha: 1,
				rotation: 0
			});
		});
	}

	public getClosestPoint(
		center: geometry.Vector2,
		size: geometry.Size,
		position: geometry.Vector2,
		maxDistance: number
	): number {
		let point: number = -1;
		let distance: number = 100000;

		for (this._i = 0; this._i < this._path.length; this._i++) {
			this._x = center.x + this._path[this._i].x * size.w;
			this._y = center.y + this._path[this._i].y * size.h;
			this._distance = Math.hypot(this._x - position.x, this._y - position.y);
			if (this._distance < maxDistance && this._distance < distance) {
				distance = this._distance;
				point = this._i;
			}
		}

		return point;
	}

	public get type(): LookupType {
		return LookupType.TRI;
	}

	public get total(): number {
		return this._path.length;
	}

	public get table(): Array<particles.ParticleLookupProps> {
		return this._path;
	}

	public get(index: number): particles.ParticleLookupProps {
		return this._path[index];
	}
}
